import type { BillingInterval } from '@/utils/billing';

export type PaymentMethod = 'online' | 'invoice';

export function canShowInvoicePaymentRequest(params: {
  billingInterval: BillingInterval;
  invoiceEnabled?: boolean;
  isCheckoutFlow: boolean;
}): boolean {
  return params.isCheckoutFlow && params.invoiceEnabled === true && params.billingInterval === 'year';
}

export function normalizeInvoicePaymentRequest(params: {
  billingInterval: BillingInterval;
  invoiceEnabled?: boolean;
  invoicePaymentRequested: boolean;
  isCheckoutFlow: boolean;
}): boolean {
  return params.invoicePaymentRequested && canShowInvoicePaymentRequest(params);
}
